import { z } from 'zod';
import { zDbId } from '~/plugins/zod/utils';
import { CategoryDetailSchema } from '../categories/_types';
import { CategoryItemDetail, CategoryItemDetailSchema, LocalizedValueSchema } from '../links/_types';
import { AppFileInfoSchema } from '../files/_types';

export const RuleOptionLimitSchema = z.object({
    Id: zDbId(),
    OptionId: zDbId(),
    IsAllowing: z.boolean(),
});

export const RuleOptionInfoSchema = z.object({
    Id: zDbId(),
    Nomenclature: z.string(),
    Item: CategoryItemDetailSchema,
});

export const RuleOptionDetailSchema = z.object({
    Id: zDbId(),
    IsDefault: z.boolean(),
    Nomenclature: z.string(),
    Item: CategoryItemDetailSchema,
    Limits: RuleOptionLimitSchema.array(),
});

export const RuleInfoSchema = z.object({
    Id: zDbId(),
    Name: z.string(),
    Document: AppFileInfoSchema.nullable(),
});

export const RuleDetailSchema = z.object({
    Id: zDbId(),
    Name: z.string(),
    Readonly: z.boolean(),
    Options: RuleOptionDetailSchema.array(),
    Document: AppFileInfoSchema.nullable(),
});

export const CategoryItemConfigSchema = z
    .object({
        Item: CategoryItemDetailSchema,
        Rules: RuleDetailSchema.array(),
        Accessories: CategoryItemDetailSchema.array(),
    })
    .transform((val) => ({
        ...val,
        ItemId: val.Item.Id,
    }));

export const NomenclatureConfigInfoSchema = z.object({
    Rule: RuleInfoSchema,
    Option: RuleOptionInfoSchema,
});

export const NomenclatureConfigSnapshotInfoSchema = z.object({
    Rule: z.object({
        Id: zDbId(),
        Name: LocalizedValueSchema,
    }),
    Option: z.object({
        Id: zDbId(),
        Nomenclature: z.string(),
        Item: z.object({
            Id: zDbId(),
            Code: z.string(),
            Name: LocalizedValueSchema,
        }),
    }),
});
// vyuzijeme 'z.custom' abychom nevalidovali data, ktera jsou pouze pomocna pro zobrazeni formulare
export const CategoryItemConfigCheckItemFormDataSchema = z.object({
    RuleId: z.custom<RuleDetail>(),
    Name: z.custom<string>(),
    OptionId: RuleOptionDetailSchema,
    Readonly: z.custom<boolean>(),
    Options: z.custom<RuleOptionDetail[]>(),
});

export const CategoryItemConfigCheckFormDataSchema = z.object({
    // vyuzijeme 'z.custom' abychom nevalidovali data, ktera jsou pouze pomocna pro zobrazeni formulare
    Item: z.custom<CategoryItemDetail>(),
    Configuration: z.array(CategoryItemConfigCheckItemFormDataSchema),
});

// @plachtova: pro FE dictionary je celkem na nic, takze si to prevedeme na array
export const SearchCategoryItemResponseSchema = z.preprocess((data) => {
    if (data == null) return [];
    if (typeof data === 'object') return Object.values(data);
    return [];
}, CategoryDetailSchema.array());

export type RuleOptionLimit = z.infer<typeof RuleOptionLimitSchema>;
export type RuleOptionInfo = z.infer<typeof RuleOptionInfoSchema>;
export type RuleOptionDetail = z.infer<typeof RuleOptionDetailSchema>;
export type RuleInfo = z.infer<typeof RuleInfoSchema>;
export type RuleDetail = z.infer<typeof RuleDetailSchema>;
export type CategoryItemConfig = z.infer<typeof CategoryItemConfigSchema>;
export type NomenclatureConfigInfo = z.infer<typeof NomenclatureConfigInfoSchema>;
export type NomenclatureConfigSnapshotInfo = z.infer<typeof NomenclatureConfigSnapshotInfoSchema>;
export type CategoryItemConfigCheckItemFormData = z.infer<typeof CategoryItemConfigCheckItemFormDataSchema>;
export type CategoryItemConfigCheckFormData = z.infer<typeof CategoryItemConfigCheckFormDataSchema>;
export type SearchCategoryItemResponse = z.infer<typeof SearchCategoryItemResponseSchema>;
